<header class="sticky top-0 z-40 w-full border-b border-gray-200 bg-white/95 backdrop-blur-sm dark:border-gray-700 dark:bg-gray-900/95">
  <div class="flex h-16 items-center gap-4 px-4 sm:px-6 lg:px-8">
    
    <!-- Mobile sidebar toggle -->
    <button
      (click)="onToggleSidebar()"
      class="flex-shrink-0 rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 lg:hidden dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
      aria-label="Abrir menú"
    >
      <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>

    <!-- Enhanced Multi-Purpose Search Bar -->
    <div class="search-container relative flex-1">
      <!-- Search overlay for mobile -->
      <div 
        *ngIf="isSearchFocused"
        class="fixed inset-0 z-20 bg-black bg-opacity-25 sm:hidden"
        (click)="clearSearch()">
      </div>

      <div class="relative z-30">
        <div class="relative">
          <!-- Search icon -->
          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>

          <!-- Search input -->
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
            (focus)="isSearchFocused = true"
            placeholder="Buscar proyectos, estudiantes, terceros, comprobantes, órdenes de trabajo..."
            class="block w-full rounded-xl border border-gray-300 bg-gray-50 py-3 pl-11 pr-12 text-sm text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:bg-gray-600"
          />

          <!-- Clear search button -->
          <div class="absolute inset-y-0 right-0 flex items-center pr-3">
            <button
              *ngIf="searchTerm"
              (click)="clearSearch()"
              class="rounded-lg p-1.5 text-gray-400 hover:bg-gray-200 hover:text-gray-600 dark:hover:bg-gray-600 dark:hover:text-gray-300"
              aria-label="Limpiar búsqueda"
            >
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <!-- Search status indicator -->
            <div *ngIf="!searchTerm" class="flex items-center space-x-2 text-xs text-gray-400">
              <kbd class="hidden sm:inline-flex items-center rounded border border-gray-200 px-2 py-1 font-medium dark:border-gray-600">
                Ctrl + K
              </kbd>
            </div>
          </div>
        </div>

        <!-- Enhanced Search Results -->
        <div 
          *ngIf="isSearchFocused"
          class="absolute left-0 right-0 mt-2 origin-top rounded-xl border border-gray-200 bg-white shadow-2xl focus:outline-none dark:border-gray-600 dark:bg-gray-800 z-50"
        >
          <!-- Loading state -->
          <div *ngIf="isLoading" class="flex items-center justify-center py-12">
            <div class="flex flex-col items-center space-y-3 text-gray-500">
              <div class="h-8 w-8 animate-spin rounded-full border-2 border-blue-500 border-t-transparent"></div>
              <span class="text-sm">Buscando en toda la aplicación...</span>
            </div>
          </div>

          <!-- Search results -->
          <div *ngIf="!isLoading && searchResults" class="max-h-96 overflow-y-auto custom-scrollbar">
            <!-- No results -->
            <div *ngIf="!searchResults?.projects?.length && !searchResults?.participants?.length && !searchResults?.thirdParties?.length" 
                 class="px-6 py-12 text-center">
              <div class="mx-auto h-24 w-24 text-gray-300 dark:text-gray-600">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 class="mt-4 text-lg font-medium text-gray-900 dark:text-white">No se encontraron resultados</h3>
              <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
                Intenta con otros términos de búsqueda o verifica la ortografía
              </p>
            </div>

            <!-- Results sections -->
            <div *ngIf="searchResults?.projects?.length || searchResults?.participants?.length || searchResults?.thirdParties?.length" class="py-2">
              
              <!-- Projects -->
              <div *ngIf="searchResults?.projects?.length" class="border-b border-gray-100 dark:border-gray-700">
                <div class="bg-gradient-to-r from-blue-50 to-blue-100 px-6 py-3 dark:from-blue-900/20 dark:to-blue-800/20">
                  <div class="flex items-center justify-between">
                    <h4 class="flex items-center text-sm font-semibold text-blue-900 dark:text-blue-100">
                      <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                      </svg>
                      Proyectos
                    </h4>
                    <span class="text-xs text-blue-700 dark:text-blue-300">{{searchResults.projects.length}} resultados</span>
                  </div>
                </div>
                <div *ngFor="let project of searchResults.projects" 
                     (click)="navigateToResult('project', project.id)"
                     class="flex cursor-pointer items-center justify-between px-6 py-4 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors">
                  <div class="flex items-center space-x-4">
                    <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-100 dark:bg-blue-900">
                      <svg class="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                      </svg>
                    </div>
                    <div>
                      <p class="font-medium text-gray-900 dark:text-white">{{ project.name }}</p>
                      <p class="text-sm text-gray-500 dark:text-gray-400">{{ project.projectId }}</p>
                    </div>
                  </div>
                  <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>

              <!-- Participants -->
              <div *ngIf="searchResults?.participants?.length" class="border-b border-gray-100 dark:border-gray-700">
                <div class="bg-gradient-to-r from-green-50 to-green-100 px-6 py-3 dark:from-green-900/20 dark:to-green-800/20">
                  <div class="flex items-center justify-between">
                    <h4 class="flex items-center text-sm font-semibold text-green-900 dark:text-green-100">
                      <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      Estudiantes
                    </h4>
                    <span class="text-xs text-green-700 dark:text-green-300">{{searchResults.participants.length}} resultados</span>
                  </div>
                </div>
                <div *ngFor="let participant of searchResults.participants" 
                     (click)="navigateToResult('participant', participant.id)"
                     class="flex cursor-pointer items-center justify-between px-6 py-4 hover:bg-green-50 dark:hover:bg-green-900/20 transition-colors">
                  <div class="flex items-center space-x-4">
                    <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-green-100 dark:bg-green-900">
                      <svg class="h-5 w-5 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                    </div>
                    <div>
                      <p class="font-medium text-gray-900 dark:text-white">{{ participant.firstName }} {{ participant.lastName }}</p>
                      <p class="text-sm text-gray-500 dark:text-gray-400">{{ participant.documentId }}</p>
                    </div>
                  </div>
                  <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>

              <!-- Third Parties -->
              <div *ngIf="searchResults?.thirdParties?.length">
                <div class="bg-gradient-to-r from-purple-50 to-purple-100 px-6 py-3 dark:from-purple-900/20 dark:to-purple-800/20">
                  <div class="flex items-center justify-between">
                    <h4 class="flex items-center text-sm font-semibold text-purple-900 dark:text-purple-100">
                      <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                      Terceros
                    </h4>
                    <span class="text-xs text-purple-700 dark:text-purple-300">{{searchResults.thirdParties.length}} resultados</span>
                  </div>
                </div>
                <div *ngFor="let third of searchResults.thirdParties" 
                     (click)="navigateToResult('third-party', third.id)"
                     class="flex cursor-pointer items-center justify-between px-6 py-4 hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-colors">
                  <div class="flex items-center space-x-4">
                    <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-purple-100 dark:bg-purple-900">
                      <svg class="h-5 w-5 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                    </div>
                    <div>
                      <p class="font-medium text-gray-900 dark:text-white">{{ third.firstName }} {{ third.lastName }}</p>
                      <p class="text-sm text-gray-500 dark:text-gray-400">{{ third.documentId }}</p>
                    </div>
                  </div>
                  <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Quick tips -->
          <div *ngIf="!isLoading && !searchResults && searchTerm" class="border-t border-gray-100 bg-gray-50 px-6 py-4 dark:border-gray-700 dark:bg-gray-700">
            <div class="text-center">
              <p class="text-sm text-gray-600 dark:text-gray-400">
                <span class="font-medium">Búsqueda inteligente:</span> Encuentra proyectos, estudiantes, terceros y más
              </p>
              <div class="mt-2 flex items-center justify-center space-x-4 text-xs text-gray-500 dark:text-gray-500">
                <span class="flex items-center">
                  <kbd class="mr-1 inline-flex items-center rounded border border-gray-200 px-1.5 py-0.5 font-medium dark:border-gray-600">Enter</kbd>
                  Buscar todo
                </span>
                <span class="flex items-center">
                  <kbd class="mr-1 inline-flex items-center rounded border border-gray-200 px-1.5 py-0.5 font-medium dark:border-gray-600">Esc</kbd>
                  Cerrar
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>